'use client';
import React, { useState } from 'react';
import StarbucksCardDisplay from './StarbucksCardDisplay';
import QRCodeDisplay from './QRCodeDisplay';
import ReloadCard from './ReloadCard';
import TransactionHistory from './TransactionHistory';
import EGiftSection from './EGiftSection';
import Icon from '@/components/ui/AppIcon';

type Tab = 'qr' | 'yukle' | 'gecmis' | 'egift';

export default function PaymentClient() {
  const [balance, setBalance] = useState(245.50);
  const [activeTab, setActiveTab] = useState<Tab>('qr');

  const tabs: Array<{ id: Tab; label: string; icon: string }> = [
    { id: 'qr', label: 'QR Kod', icon: 'QrCodeIcon' },
    { id: 'yukle', label: 'Yükle', icon: 'PlusCircleIcon' },
    { id: 'gecmis', label: 'Geçmiş', icon: 'ClockIcon' },
    { id: 'egift', label: 'eHediye', icon: 'GiftIcon' },
  ];

  return (
    <div>
      {/* Header */}
      <div className="bg-primary-dark px-5 pt-12 pb-6">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center">
            <span className="text-primary font-black text-sm">S</span>
          </div>
          <span className="text-white font-bold text-lg">Mobil Ödeme</span>
        </div>
        <StarbucksCardDisplay balance={balance} />
      </div>

      {/* Tabs */}
      <div className="bg-card border-b border-border px-4">
        <div className="flex gap-1 py-2">
          {tabs.map((tab) => (
            <button
              key={`tab-${tab.id}`}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-1 flex flex-col items-center gap-1 py-2 rounded-xl text-xs font-semibold transition-all ${
                activeTab === tab.id
                  ? 'bg-primary text-white' :'text-muted-foreground hover:text-foreground hover:bg-muted'
              }`}
            >
              <Icon name={tab.icon as any} size={18} className={activeTab === tab.id ? 'text-white' : 'text-muted-foreground'} />
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab content */}
      <div className="px-4 py-4">
        {activeTab === 'qr' && <QRCodeDisplay />}
        {activeTab === 'yukle' && <ReloadCard balance={balance} onReload={(amount) => setBalance((b) => b + amount)} />}
        {activeTab === 'gecmis' && <TransactionHistory />}
        {activeTab === 'egift' && <EGiftSection />}
      </div>
    </div>
  );
}